import { DataSecurityMonitor } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { DynamicQueryParams, KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetDataSecurityMonitorsRequest = KeyPaginationQueryParams & DynamicQueryParams;

export type GetDataSecurityMonitorsResponse = PaginatedResource<DataSecurityMonitor>;

export const getDataSecurityMonitors =
	createGetEndpoint<GetDataSecurityMonitorsRequest, GetDataSecurityMonitorsResponse>(
		(request) => `/api/v3/data-security/monitors?${getQueryString(request)}`
	);
